import { Clim81Station } from "../../types";
import { SEASON_HIGH_MAX, SEASON_HIGH_MIN, seasonMonths, stationDescription } from "../../utils/areaForecast";
import { SectionCard } from "./sectionCard";
import { IconChart, IconDrop } from "./icons";
import "./seasonCard.css";

interface SeasonCardProps {
    station: Clim81Station | null | undefined;
    stationDistance?: number | null;
    areaElevation?: number | null;
}

export function SeasonCard({ station, stationDistance, areaElevation }: SeasonCardProps) {
    const months = seasonMonths(station);
    if (!station || !months) {
        return null;
    }

    const hasHighs = months.some((m) => m.high !== undefined);
    const currentMonth = new Date().getMonth();

    return (
        <SectionCard icon={<IconChart />} title="Season">
            <p className="season__intro">
                {hasHighs
                    ? `Average high and precipitation by month. Months averaging ${SEASON_HIGH_MIN}–${SEASON_HIGH_MAX}°F are filled.`
                    : "Average precipitation by month."}
            </p>
            <ul className="season__grid">
                {months.map((m, i) => {
                    const classes = ["season__month"];
                    if (m.inSeason) classes.push("season__month--in-season");
                    if (i === currentMonth) classes.push("season__month--current");
                    return (
                        <li key={m.name} className={classes.join(" ")}>
                            <span className="season__name">{m.name}</span>
                            {hasHighs && (
                                <span className="season__high">
                                    {m.high !== undefined ? `${Math.round(m.high)}°` : "–"}
                                    <span className="cw-sr-only"> average high</span>
                                </span>
                            )}
                            <span className="season__precip">
                                <IconDrop />
                                {m.precip !== undefined ? `${m.precip.toFixed(1)}"` : "–"}
                                <span className="cw-sr-only"> precipitation</span>
                            </span>
                            {i === currentMonth && <span className="cw-sr-only">, this month</span>}
                            {m.inSeason && <span className="cw-sr-only">, climbing season</span>}
                        </li>
                    );
                })}
            </ul>
            <p className="season__source">
                {stationDescription(station, stationDistance, areaElevation)}
                {!hasHighs && " Temperature averages aren’t available for this station."}
                {" "}Actual conditions may vary.
            </p>
        </SectionCard>
    );
}
